import { render, staticRenderFns } from "./RegistrationDetailsReviewed.vue?vue&type=template&id=4825bee8&"
import script from "./RegistrationDetailsReviewed.vue?vue&type=script&lang=js&"
export * from "./RegistrationDetailsReviewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports